import React from 'react';

export default function CheckIcon(): JSX.Element {
  return (
    <svg
      width="81"
      height="82"
      viewBox="0 0 81 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="40.5" cy="40.6904" r="40.5" fill="#0047D4" />
      <path
        d="M57.7188 29.4717C58.7344 30.4092 58.7344 32.0498 57.7188 32.9873L37.7188 52.9873C36.7812 54.0029 35.1406 54.0029 34.2031 52.9873L24.2031 42.9873C23.1875 42.0498 23.1875 40.4092 24.2031 39.4717C25.1406 38.4561 26.7812 38.4561 27.7188 39.4717L36 47.6748L54.2031 29.4717C55.1406 28.4561 56.7812 28.4561 57.7188 29.4717Z"
        fill="white"
      />
    </svg>
  );
}
